export async function fetchAPI({url, method = 'GET', body, includeBundleResponse = false}) 
{
    try {
        const options = { method };
        options.credentials = 'include';

        if (body) {            
            options.headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
            options.body = JSON.stringify(body);
        }

        const response = await fetch(url, options);

        if (!response.ok) {
            //console.log(response);
            localStorage.clear();     
            window.location.href = '/SignIn'; 
            //throw new Error(`HTTP error! Status: ${response.status}`);
        }

        if (includeBundleResponse) return response;

        const data = await response.json();

        return typeof data === 'string' ? JSON.parse(data) : data;
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

export async function fetchPostAPI({url, body, includeBundleResponse = false}) 
{
    try {
       const fetchParams = {url, method : 'POST', body, includeBundleResponse };
       return fetchAPI(fetchParams);
    } catch (error) {
        console.error('Fetch error:', error);
    }
}